import { SEARCH_PARAMETERS, URL_PARAMS } from './constants';
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants'
import { PAN, CIN, BSE, NSE, GST_ANALYSIS_REQUIRED_FIELDS, GST_ANALYSIS_NOT_REQUIRED_FIELDS} from '../../Cases/CommonComponent/DataAutomationDetails/constants'
export function showCases(tasks, status) {
    let cases = []
    for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].status === status)
            cases.push(tasks[i])
    }
    return cases;
}

export const getPageDescriptionBody = (pageDescription) => {
    return {
        status: pageDescription.status,
        pageNo: pageDescription.pageNo,
        pageSize: pageDescription.pageSize,
        sorted: pageDescription.sorted
    }
}

export const setRequestBody = (productType, caseType, selectedCorporate, date, searchText, selectedProducts) => {
    const tempCorporate = [];
    selectedCorporate.forEach(data => {
        tempCorporate.push(data.value);
    });

    const tempProducts = [];
    if (selectedProducts && Array.isArray(selectedProducts)) {
        selectedProducts.forEach(product => {
            tempProducts.push(product.value);
        });
    }

    // Regex patterns for auto-detection
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const misOrderIdRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    let counterpartyName = '';
    let gstNo = '';
    let panNo = '';
    let cinNumber = '';
    let misOrderId='';

    if (searchText && searchText.trim() !== '') {
         const trimmedText = searchText.trim();
        // Auto-detect using regex
        if (misOrderIdRegex.test(trimmedText)) {
            misOrderId = trimmedText;  // keep original case
        } else {
            const input = trimmedText.toUpperCase(); // only uppercase for other checks
            if (gstRegex.test(input)) gstNo = input;
            else if (panRegex.test(input)) panNo = input;
            else if (checkMCANumber(input)) cinNumber = input;  
            else counterpartyName = trimmedText; // keep original for name
        }
    }
    return {
        counterpartyName,
        gstNo,
        panNo,
        cinNumber,
        misOrderId,
        corporateIdList: tempCorporate,
        productIdList: tempProducts,
        fromDate: (date.fromDate) ? moment(date.fromDate,"DD-MMM-YYYY").format("YYYY-MM-DD")+"T00:00:00+05:30" : null,
        toDate: (date.toDate) ? moment(date.toDate,"DD-MMM-YYYY").format("YYYY-MM-DD")+"T23:59:59+05:30" : null,
        productType: productType ? productType.label : null,
        caseType: caseType ? (caseType.label === 'INDIAN' ? 'DOMESTIC' : caseType.label) : null
    };
};

export const setAppliedFilters = (productType, caseType, selectedCorporate, date, selectedProducts) => {
    let tempSelectedFilters = []
    selectedCorporate.forEach(item => {
        item["label"]=encodeURIComponent(item["label"]);
        tempSelectedFilters.push(item);
    });
    if (date.toDate && date.fromDate) {
        tempSelectedFilters.push({ label: (moment(date.fromDate).format(DATE_FORMAT) + ' to ' + moment(date.toDate).format(DATE_FORMAT)), value: 'date' })
    }
    if (productType) {
        tempSelectedFilters.push({ label: productType.label, value: 'productType' });
    }
    if (caseType) {
        tempSelectedFilters.push({ label: caseType.label, value: 'caseType' });
    }
    if (selectedProducts && selectedProducts.length > 0) {
    selectedProducts.forEach(item => {
      tempSelectedFilters.push({
        value: item.value,        
        label: item.label,        
        type: 'product'
      });
    });
  }
    return tempSelectedFilters
}

export const deleteAppliedFilters = (removeFilter, appliedFilters) => {
    let tempAppliedFilters = [...appliedFilters];
    tempAppliedFilters.forEach((item, index, element) => {
        if (item.value === removeFilter.value) {
            appliedFilters.splice(index, 1)
        }
    })
    return appliedFilters;
}

export const deleteEntityFilter = (selectedEntity, removeFilter) => {
    let tempSelectedData = copyArray(selectedEntity);
    for (let i = 0; i < tempSelectedData.length; i++) {
        if (tempSelectedData[i].value === removeFilter.value) {
            tempSelectedData.splice(i, 1);
            break;
        }
    }
    return tempSelectedData;
}

export const setRequestBodyDataAutomation = (dataAutomation, metadata, caseData) => {

    let requestBody = [], 
    tempMetadata = { 
        counterpartyName: metadata.counterpartyName, 
        corporateId: metadata.corporateId, 
        counterpartyId: metadata.counterpartyId,
        caseId: metadata.caseId
    };
    if ("API" == metadata.requestType) {
        tempMetadata = { ...tempMetadata, requestType: "API" }
    }
    if (dataAutomation.GST) {
        if (metadata.gstNo) {
            requestBody.push({
                ...tempMetadata,
                crawlerName: 'GST',
                crawlerId: [metadata.gstNo],
                panNo: metadata.panNo
            });
        }
        if (metadata.panNo) {
            requestBody.push({
                ...tempMetadata,
                crawlerName: 'GST',
                crawlerId: [""],
                panNo: metadata.panNo
            });
        }
    }
    if (dataAutomation.PAN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'PAN',
            crawlerId: Array.isArray(metadata.PAN) ? metadata.PAN : [metadata.PAN]
        })
    }
    if (dataAutomation.MCA) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'MCA',
            crawlerId: Array.isArray(metadata.MCA) ? metadata.MCA : [metadata.MCA]
        })
    }
    if (dataAutomation.DIN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'DIN',
            crawlerId: Array.isArray(metadata.DIN) ? metadata.DIN : [metadata.DIN]
        })
    }
    if (dataAutomation.EPF) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'EPF',
            crawlerId: Array.isArray(metadata.EPF) ? metadata.EPF : metadata.EPF.split(",")
        })
    }

    if (dataAutomation.RATINGS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'RATINGS',
            crawlerId: [caseData.RATINGS],
            ratingsSearchType: caseData.ratingsSearchType
        })
    }

    if (dataAutomation.STOCK_EXCHANGE) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'STOCK_EXCHANGE',
            crawlerId: [caseData.STOCK_EXCHANGE],
            stockType: caseData.stockType
        })
    }

    if (dataAutomation.GST_ANALYSIS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'GST_ANALYSIS',
            crawlerId: [metadata.GST_ANALYSIS],
            [GST_ANALYSIS_REQUIRED_FIELDS.fromDate]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.fromDate],
            [GST_ANALYSIS_REQUIRED_FIELDS.toDate]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.toDate],
            [GST_ANALYSIS_REQUIRED_FIELDS.email]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.email],
            [GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]: metadata[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]
        })
    }

    return requestBody
}
export const checkGSTNumber = (g) => {
    if(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(g)  && g.length === 15 ){
        return true
    }else{
        return false
    }
}

export const checkEPFNumber = (epfNumbers) => {
    let epfArray = epfNumbers.split(",");
    let result = true;
    if (epfArray !== undefined) {
        for (var i = 0; i < epfArray.length; i++) {
            if (epfArray[i].length === 15) {
                if (!/[A-Z]{5}[0-9A-Z]{10}/.test(epfArray[i])) {
                    result = false
                    break
                }
            } else {
                result = false
                break
            }
        }
        return result;
    } else {
        return false
    }
}
export const checkMCANumber = (mcaNumber) => {
    if (/[U|L]{1}\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}/.test(mcaNumber)  && mcaNumber.length === 21) {//
        return true;
    }
    else if (/[F]{1}\d{5}/.test(mcaNumber)  && mcaNumber.length === 6) {//F12345
        return true;
    }
    else if (/[A]{1}[A-Z]{2}[-]{1}\d{4}/.test(mcaNumber) && mcaNumber.length === 8) {//AAA-2756
        return true;
    }else{
        return false;
    }
}

export const checkDINNumber = (dinNumber) => {
    const normalizedDin = Array.isArray(dinNumber) ? dinNumber[0] : dinNumber;
    return /^\d{8}$/.test(normalizedDin);
}

export const checkPANNumber = (panNumber) => {
    if(/[A-Z]{5}\d{4}[A-Z]{1}/.test(panNumber) && panNumber.length === 10){
        return true;
    }else{
        return false;
    }
}

export const validateAutomationData = (automationSelected, selectedData, caseData) => {
    let flag = true;
    let errorMessage="";
    if (Object.keys(automationSelected).length === 0) {
        return "Enter Valid Data"
    }
    if (automationSelected.GST) {
        if (checkGSTNumber(selectedData.gstNo)) {
            flag = true;
        } else {
            if (selectedData.panNo) {
                flag = true;
            } else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid GST Number Format "
            }
        }
    }
    if (automationSelected.PAN) {
        if(selectedData.PAN === undefined){
            selectedData.PAN = selectedData.panNo
        }
        if (checkPANNumber(selectedData.PAN)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid PAN Number Format "
        }
    }
    if (automationSelected.MCA) {
        if(selectedData.MCA === undefined){
            selectedData.MCA = selectedData.cinNumber
        }
        if (checkMCANumber(selectedData.MCA)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid CIN Number Format "
        }
    }
    if (automationSelected.DIN) {
        if (selectedData.DIN === undefined) {
            selectedData.DIN = selectedData.dinNumber
        }
        if (checkDINNumber(selectedData.DIN)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid DIN Number Format "
        }
    }
    if (automationSelected.EPF) {
        if (selectedData.EPF) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid PF Number Format "
        }
    }

    if (automationSelected.LEGAL) {
        if (caseData.LEGAL && caseData.LEGAL_name && caseData.LEGAL_name.trim().length > 2) {
            flag = true
        } else {
            flag = false
            errorMessage =  "Enter Required Data "
        }
    }
    if (automationSelected.RATINGS) {
        if(!caseData.ratingsSearchType){
            flag = false;
            errorMessage = errorMessage + "\n Select CIN or PAN for rating search"
        }else{
            if(caseData.ratingsSearchType === CIN && checkMCANumber(caseData.RATINGS)){
               flag = true
            }
            else if(caseData.ratingsSearchType === PAN && checkPANNumber(caseData.RATINGS)){
                flag = true;
            }else{
                flag = false;
                errorMessage = errorMessage + "\n Invalid CIN or PAN"
            }
        }
    }
    //BSE NSE Stock exchange
    if (automationSelected.STOCK_EXCHANGE) {
        if(!caseData.stockType){
            flag = false;
            errorMessage = errorMessage + "\n Select BSE or NSE for stock Exchange"
        }else{
            if(caseData.stockType.includes(BSE) || caseData.stockType.includes(NSE)){
               flag = true
            }
            else{
                flag = false;
                errorMessage = errorMessage + "\n Invalid Company ID"
            }
        }
    }
    // social media
    if (automationSelected.SOCIALMEDIA) {
        if (selectedData.SOCIALMEDIA) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid company Name OR Address "
        }
    }

    if (automationSelected.GST_ANALYSIS) {
        if(selectedData.GST_ANALYSIS === undefined){
            selectedData.GST_ANALYSIS = selectedData.gstNo
        }
        if(!selectedData[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]) {
            selectedData[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo] = selectedData.counterpartyPhone
        }
        for (let property in GST_ANALYSIS_REQUIRED_FIELDS) {
            if(selectedData[GST_ANALYSIS_REQUIRED_FIELDS[property]]) {
                flag = true
            }
            else {
                flag = false
                errorMessage = errorMessage + "\n Please fill all the required fields "
                break;
            }
        }
        if(flag) {
            if (checkGSTNumber(selectedData.GST_ANALYSIS)) {
                flag = true
            } else {
                flag = false
                errorMessage = errorMessage + "\n Invalid GST Number Format "
            }
        }
    }

    return errorMessage
}

export const getCounterpartyIdWithCorporateIdList = (cases) => {
    let tempData = [];
    cases.caseViewList.forEach(caseData => {
        let tempObj = {counterpartyId: caseData.counterpartyId, corporateId: caseData.corporateId}
        tempData.push(tempObj)
        // tempData.push(caseData.counterpartyId)
    })
    return tempData
}

export const updateCrawlerStatusinCaseData = (caseData, crawlerStatusData) => {
    caseData.caseViewList.forEach(cases => {
        cases.crawlerFlag = true;
        let statusArray = [];
        crawlerStatusData.forEach(status => {
            if (cases.counterpartyId === status.counterpartyId) {

                statusArray.push({
                    "crawlerName": status.crawlerName,
                    "crawlerStatus": status.crawlerStatus,
                    "failureReason": status.failureReason
                });
            }
        })
        if (statusArray.length > 0) {
            cases.crawlerStatus = getCrawlerFinalStatus(statusArray);
        } else {
            cases.crawlerStatus = statusArray;
        }

    })
    return caseData;
}

export const getCrawlerFinalStatus = (statusArray) => {
    let inprogressCount = 0, failedCount = 0, successCount = 0, partialFailedCount = 0;;
    for (let i = 0; i < statusArray.length; i++) {
        if (statusArray[i].crawlerStatus === 'INPROGRESS') {
            inprogressCount = inprogressCount + 1
        } else if (statusArray[i].crawlerStatus === 'FAILURE') {
            failedCount = failedCount + 1;
        } else if (statusArray[i].crawlerStatus === 'SUCCESS') {
            successCount = successCount + 1;
        } else if (statusArray[i].crawlerStatus === 'PARTIAL_FAILURE') {
            partialFailedCount = partialFailedCount + 1;
        }
    }
    if (inprogressCount > 0) {
        return "INPROGRESS";
    } else if (failedCount > 0) {
        return "FAILURE";
    } else if (partialFailedCount > 0) {
        return "PARTIAL_FAILURE";
    } else if (successCount > 0) {
        return "SUCCESS";
    } else {
        return "START"
    }
}

export const getStatusData = (crawlerStatusData, caseData) => {
    let statusArray = [];
    crawlerStatusData.forEach(crawlerData => {
        if (crawlerData.counterpartyId === caseData.counterpartyId) {
            statusArray.push(crawlerData);
        }
    })
    return statusArray;
}

export const updateCaseDataWithCrawlerFlag = (caseData) => {
    caseData.caseViewList.forEach(cases => {
        cases.crawlerFlag = false
    })
    return caseData
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}

export const getUrlFilter = (urlFilter) => {
    const params = new URLSearchParams(urlFilter);
    const tempFilters = {
        fromDate: params.get('dateRange') ? params.get('dateRange').split('to')[0] : null,
        toDate: params.get('dateRange') ? params.get('dateRange').split('to')[1] : null,
        productType: params.get('productType') ? { label: params.get('productType'), value: 'productType' } : undefined,
        caseType: params.get('caseType') ? { label: params.get('caseType'), value: 'caseType' } : undefined,
        selectedCorporates: params.get('corporates') ? JSON.parse(params.get('corporates')) : [],
        selectedProducts: params.get('products') ? JSON.parse(params.get('products')) : []
    };
    return tempFilters
}

export const createFilterUrl = (productType, caseType, date, selectedCorporates, selectedProducts) => {
    let url = new URLSearchParams();
    if (productType) {
        url.set('productType', encodeURIComponent(productType.label));
    }
    if (caseType) {
        url.set('caseType', encodeURIComponent(caseType.label));
    }
    if (date.fromDate && date.toDate) {
        url.set("dateRange", encodeURIComponent(moment(date.fromDate).format(DATE_FORMAT) + 'to' + moment(date.toDate).format(DATE_FORMAT)));
    }
    if (selectedCorporates.length > 0) {
        url.set('corporates', JSON.stringify(selectedCorporates));
    }
    if (selectedProducts && Array.isArray(selectedProducts) && selectedProducts.length > 0) {
        url.set('products', JSON.stringify(selectedProducts));
    }
    return decodeURIComponent(url)
}